import { TipoAcuse } from "./guia";
import { GuiaEntregaZESelect } from "./viajezeapp";
import { FirmaModel } from "./viajeapp";
import { ImportesGuiaDTO, ServiciosAdicionalesGuiaDTO } from "./guia";

/**Tipo de pago de las guías de FXC entregadas  */
export enum TipoPagoEntregaZE {
    Efectivo,
    Cheque,
    Credito
}

/**Indica una entrega en la que se encontró al cliente destino */
export interface EntregaZERealizada {
    IdRegistro: number;

    /**Viaje en el que se realizó esta entrega */
    IdViajeZE: number;

    /**Persona que recibió las guias */
    IdContactoCliente: number;

    NombreContactoRecibio: string;

    /**Tipo de pago */
    TipoPago: TipoPagoEntregaZE;

    /**Latitud de la posición de la entrega */
    PosicionLat: number | null;
    /**Longitud de la posición de la entrega */
    PosicionLng: number | null;

    /**Fecha de la entrega */
    Fecha: Date | string;

    /**Id de la forma del usuario, es la persona que recibio la guía */
    IdFirmaUsuario: number;
    FirmaUsuario: FirmaModel;

    /**Guías que fueron entregadas en este evento de entrega */
    GuiasEntregadas: GuiaEntregadaZE[];

    /**Guías que fueron rechazadas en esta entrega  */
    GuiasNoEntregadas: GuiaNoEntregadaZE[];

    /**Fotos que fueron agregadas al realizar esta entrega */
    Fotos: FotoEntregaZERealizada[];

    /**Digitos del cheque en caso de que el tipo de pago sea cheque */
    DigitosCheque: string;

}

export interface EntregaZERealizadaDTO extends EntregaZERealizada {
    IdDireccionDestino: number;
    Guias: GuiaDTOEntregaZE[];
    NombreContactoRecibio: string;
    IdContactoRecibio: number | null;
    Direccion: string;
    NombreChoferZE: string;
    NombreProveedorZE: string;
    CantGuiasEntregadas: number;
    CantGuiasRechazadas: number;
    FolioViajeZE: number;
    Liberada: boolean;
    IdChoferZE: number;
    TotalFXC: number;
    CantidadAcuses: number;
    NombreCliente: string;
    AcusesEntregar: RecordatorioAcuse[];
}

/**La guia fue rechazada por el cliente */
export interface FotoEntregaZERealizada {
    IdRegistro: number;

    /**Entrega realizada a la que pertenece la foto */
    IdEntregaZERealizada: number;

    /**Nombre completo de la foto agregada */
    NombreCompletoFoto: string;

    /**Tipo de archivo que es la foto */
    MimeType: string;

    /**contenido del archivo subido */
    ContenidoFoto: string;
}

/**Indica que cierta guia fue entregada */
export interface GuiaEntregadaZE {

    IdRegistro: number;

    /**La guia que se entregó */
    IdGuia: number;

    /**
     * True si esta guia fue pagada en la entrega. Es posible que una guia FXC sea pagada antes de que sea entregada asi que se almacena este valor
     * para saber cuales guias fueron pagadas en la entrega y cuales fueron pagadas antes de la entrega
     */
    PagadaEnEntrega: boolean;

    /**Id de la entrega donde se entregó esta guía */
    IdEntregaZERealizada: number;
}

/**La guia fue rechazada por el cliente */
export interface GuiaNoEntregadaZE {
    IdRegistro: number;

    /**La guia rechazada */
    IdGuia: number;

    /**Entrega realizada */
    IdEntregaZERealizada: number;
    EntregaZERealizada: EntregaZERealizada;

    /**Motivo de la no entrega */
    IdMotivoNoEntrega: number;

    MotivoNoEntrega: MotivoNoEntrega;
    MotivoRechazo: string;
}

/**Un motivo de no entrega para las entregas a ZE */
export interface MotivoNoEntrega {
    IdRegistro: number;

    /**Descripción del motivo  */
    Descripcion: string;
}

export interface ParametrosGuiasEntregadaZE {
    IdViajeZE: number;
    IdDireccionDestino: number;
    IdEntrega: number | null;
}

export interface GuiaDTOEntregaZE {
    IdRegistro: number;
    Folio: string;
    FletePorCobrar: boolean;
    Importes: ImportesGuiaDTO;
    /**Descripciones de los contenidos y descripciones de los paquetes */
    DescripcionPaquetesTexto: string;
    /**Cantidad total de sobres */
    CantidadSobres: number;
    ServiciosAdicionales: ServiciosAdicionalesGuiaDTO;
}

export interface RecordatorioAcuse {
    IdGuia: number;
    Folio: string;
    TipoAcuse: TipoAcuse;
    RequerimientoAcuse: string;
}

export interface InfoEntregaZE {
    NombreCliente: string;
    NombreDestino: string;
    CantGuias: number;
    GuiasEntregadas: number;
    GuiasRechazadas: number;
    GuiasExcluidas: number;
    Finalizado: boolean;
    Firma: string;
    AcusesEntregar: RecordatorioAcuse[];
}

export interface FiltroEntregaZE {
    IdChofer: number | null;
    Liberada: boolean | null;
    NecesitaLiberacion: boolean | null;
}


// WEBPACK FOOTER //
// ./app/models/entregazerealizada.ts